import slice from './slice';

export const { setDisplayZones } = slice.actions;